import { Component } from '@angular/core';

@Component({
  selector: 'app-item-concept',
  template: `
    <div></div>
  `,
  styleUrls: []
})
export class ItemConceptComponent {

}
